// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"59":"cff81e48","304":"89bcdb2f","427":"12013c71","920":"7d1ff25f"}[chunkId] + ".css";
};